<!-- <a  class="hero"> -->
<!-- <div class="hero"> -->
  <div class="content">
    <img src="assets/images/tn-logo.png" class="logo" />

  <a
    href="https://www.vestajobs.com/jobs/fd4f56e6-ac86-46b2-a87a-1b3958c086da"
    target="_blank"
    class="apply-link"
  >
    <!-- <img src="assets/images/apply.png" class="apply-btn" alt="Apply Now" /> -->
     <button class="myBtn apply-btn">APPLY NOW</button>
  </a>
  
    <div class="left">
      <br />
      <br />
      <h1 class="mainText">
        PROJECT<br />
        CONSULTANT<br />
        INTERN
      </h1>

      <h2 class="mainText">SUMMER 2026</h2>
      <p style="color: #eeeeee;">1 de junio – 17 de julio de 2026</p>

      <p class="highlight">
        La entrevista no espera:<br />
        disponible 24/7, online e<br />
        impulsada por IA
      </p>

      <div class="info">
        <div class="textInfo">
          <img src="assets/images/icon1.png" width="26" /> Truenorth Corp.
        </div>
        <div class="textInfo">
          <img src="assets/images/icon2.png" width="26" /> Puerto Rico
        </div>
        <div class="textInfo">
          <img src="assets/images/icon3.png" width="26" /> Fecha límite para
          aplicar: 24 de abril
        </div>
      </div>
    </div>

    <div class="right">
      
      <img src="assets/images/people.png" alt="Personas" />
    </div>
  </div>
<!-- </div> -->
